import Vue from "vue";

export default {
    SET_HEIGHT_FRAME(state, payload) {
        state.calculadoraHeight = payload;
    },
    SET_IS_PROVEEDOR(state, payload) {
        state.isProveedor = payload;
    },
    SET_LOCALE(state, payload) {
        state.locale = payload;
    },
    SET_COMERCIAL(state, payload) {
        state.comercial = payload;
        if (payload)
            window.localStorage.setItem('authToken-calculator', payload.authToken);
    },
    SET_USER_LIST(state, payload) {
        if (!payload) {
            state.userList = {};
            return;
        }

        const newList = {};
        payload.listClient.forEach(client => {
            const { clientId, clientName } = client;
            const label = `${clientId} - ${clientName}`;
            client.listUser.forEach(user => user.label = `${user.user} - ${user.name}`);
            newList[clientId] = { ...client, label, _order: Date.now() };
        });

        // Combinamos: nuevos primero, luego los que ya estaban (evitando duplicados por clave)
        state.userList = { ...newList, ...state.userList };
    },
    CLIENT_LOGIN(state, payload) {
        if (!payload) {
            state.loggedClient = null;
            return;
        }
        payload.users = payload.users.map(u => {
            return {
                ...u,
                label: `${u.user} - ${u.name}`
            }
        })
        state.loggedClient = payload;
    },
    SET_USER_OF_CLIENT(state, payload) {
        state.userOfClient = payload;
    },
    SET_KEY(state, payload) {
        state.key = payload;
    },
    SET_RESET_CALCULADORA(state, payload) {
        state.resetCalculadora = payload;
    },
    SET_COLOR(state, payload) {
        state.colorSelected = payload;
    },
    SET_COMPANY_VALUE(state, payload) {
        state.company = payload;
    },
    SET_YOU_REPROCESOS(state, payload) {
        state.youReprocesosId = payload.identificador;
        state.youReprocesosConfig = payload.configuration;
        state.youReprocesosSession = payload.session;
    },
    SET_INIT_LOADER_YOUREPROCESOS(state, payload) {
        state.initLoaderYouReprocesos = payload;
    },
    SET_NUMEROS_DTF(state, payload) {
        state.optionsNumerosDtf = payload;
    },
    SET_NUMEROS_TRASNFER(state, payload) {
        state.optionsNumerosTransfer = payload.map(o => {
            return { ...o, label: o.Label, value: o.Type }
        });
    },
    UPDATE_SIZE_DIGITAL_OPTIONS(state, { position, options }) {
        /** options en roly
       * {
            "code": "Y3",
            "value": "1200",
            "label": "30x40 (1200 cm2)"
        },

        options en stamina
        {"code":"W1","value":"5","label":"- 5 cm2"}
       */

        Vue.set(state.sizeDigitalOptions, position, options.tamanos.map(o => {
            const hasDimensions = o.label.includes('x');
            const item = { ...o, value: Number.parseInt(o.value) };

            if (hasDimensions) {
                const parts = o.label.split('x');
                item.width = Number.parseInt(parts[0]) * 10;
                item.height = Number.parseInt(parts[1].split(' ')[0]) * 10;
            }

            return item;
        }));

    },
    CLEAN_SIZE_DIGITAL(state) {
        state.sizeDigitalOptions = {};
    },
    SET_SHOP_VALUE(state, payload) {
        state.shop = payload;
    },
    SET_CATALOG_COLORS(state, payload) {
        state.catalogColors = payload;
    },
    SET_CATALOG_SIZES(state, payload) {
        state.catalogSizes = payload;
    },
    UPDATE_SAVING_3D_DESIGN(state, payload) {
        if (payload) {
            state.saving3dDesign++;
        }
        else {
            state.saving3dDesign--;
        }
    }

}